import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { FloatingPattern } from '../components/common';
import {
    HeroVideoSection,
    TextOnlySection,
    ImageTextSection,
    ThinTextSection,
    TestimonialsSection,
} from '../components/sections';

const HomeContainer = styled.div`
    position: relative;
    padding-top: 70px; /* Account for fixed navigation bar */
    overflow-x: hidden;
`;

export const HomePage: React.FC = () => {
    return (
        <HomeContainer>
            <FloatingPattern />
            {/* Section 1: Hero Video Background */}
            <HeroVideoSection
                videoSrc="/videos/hero-background.mp4"
                posterImage="/images/posters/hero-background-poster.jpg"
                title="LIVE MUSIC EXCELLENCE"
                header="The Butterscotch Boys bring BIG energy to every event"
                headerHighlight="BIG"
                paragraph="From intimate venues to large festivals, we deliver unforgettable performances that keep your audience engaged and coming back for more."
                buttonText="Book Us Now"
                buttonHref="/contact"
            />

            {/* Section 2: Text Only */}
            <TextOnlySection
                title="WHO WE ARE"
                header="Professional musicians solving your entertainment needs"
                headerHighlight="entertainment needs"
                paragraph="We understand the challenges of finding reliable, high-quality live music. Whether you're filling your venue on a Tuesday night or headlining a weekend festival, we bring the professionalism and talent that makes your event a success."
                backgroundColor={theme.colors.backgroundLighter}
            />

            {/* Section 3: Image Left, Text Right */}
            <ImageTextSection
                imageSrc="/images/section-image-1.jpg"
                imageAlt="The Butterscotch Boys performing live"
                imagePosition="left"
                title="VENUE OWNERS"
                header="Fill your venue with crowds that stay"
                headerHighlight="crowds that stay"
                paragraph="Struggling with slow nights? We create an atmosphere that draws people in and keeps them ordering. Our diverse setlist appeals to all ages, turning casual visitors into regular customers."
                buttonText="Check Availability"
                buttonHref="/contact"
                backgroundColor={theme.colors.backgroundDarker}
            />

            {/* Section 4: Thin Text Section */}
            <ThinTextSection
                title="OUR APPROACH"
                header="More than just a band"
                headerHighlight="More than"
                paragraph="We handle everything from sound setup to crowd engagement, so you can focus on running your business. Professional, punctual, and always ready to adapt to your venue's unique needs."
                backgroundColor={theme.colors.backgroundLighter}
            />

            {/* Section 5: Text Left, Image Right */}
            <ImageTextSection
                imageSrc="/images/section-image-2.jpg"
                imageAlt="Festival performance by The Butterscotch Boys"
                imagePosition="right"
                title="FESTIVAL ORGANIZERS"
                header="Headline acts that deliver memorable experiences"
                headerHighlight="memorable experiences"
                paragraph="Need a reliable headliner that can command a stage and energize thousands? We bring festival-ready production, crowd interaction expertise, and a setlist that keeps the energy high from first song to last."
                buttonText="Get a Quote"
                buttonHref="/contact"
                backgroundColor={theme.colors.backgroundDarker}
            />

            {/* Section 6: Testimonials */}
            <TestimonialsSection
                backgroundColor={theme.colors.backgroundLighter}
                title="WHAT PEOPLE SAY"
                header="Trusted by venues and festivals across the region"
                headerHighlight="Trusted"
                paragraph="Don't just take our word for it. Here's what our clients have to say about working with The Butterscotch Boys."
                testimonials={[
                    {
                        quote: 'The Butterscotch Boys turned our struggling Tuesday nights into our busiest night of the week. Their professionalism and talent are unmatched.',
                        authorName: 'Sarah Mitchell, Venue Owner',
                        authorImage: '/images/testimonials/person-1.jpg',
                    },
                    {
                        quote: "We've booked them three years running for our summer festival. They know how to work a crowd and always deliver an incredible show.",
                        authorName: 'Marcus Chen, Festival Director',
                        authorImage: '/images/testimonials/person-2.jpg',
                    },
                    {
                        quote: "Finally, a band that shows up on time, sounds amazing, and actually cares about making our event successful. Can't recommend them enough.",
                        authorName: 'Jennifer Rodriguez, Event Coordinator',
                        authorImage: '/images/testimonials/person-3.jpg',
                    },
                ]}
            />

            {/* Section 7: Footer Video Background */}
            <HeroVideoSection
                videoSrc="/videos/footer-background.mp4"
                posterImage="/images/posters/footer-background-poster.jpg"
                title="READY TO ELEVATE YOUR EVENT?"
                header="Let's make your next event unforgettable"
                headerHighlight="unforgettable"
                paragraph="Whether you need a band for a single night or a long-term partnership, we're here to help. Get in touch and let's discuss how we can bring our energy to your venue or festival."
                buttonText="Start the Conversation"
                buttonHref="/contact"
            />
        </HomeContainer>
    );
};
